import { useEffect, useRef } from "react";

interface UseBackButtonProps {
    isOpen: boolean;
    onBack: () => void;
}

export const useBackButton = ({ isOpen, onBack }: UseBackButtonProps) => {
    const handlerRef = useRef(onBack);

    // Обновляем ref при изменении callback
    useEffect(() => {
        handlerRef.current = onBack;
    }, [onBack]);

    useEffect(() => {
        if (!window.Telegram?.WebApp) return;

        const tg = window.Telegram.WebApp;

        // Wrapper функция для использования актуального callback
        const handleBackClick = () => {
            handlerRef.current();
        };

        if (isOpen) {
            // Показываем кнопку и добавляем обработчик
            tg.BackButton.show();
            tg.BackButton.onClick(handleBackClick);
        } else {
            // Скрываем кнопку и удаляем обработчик
            tg.BackButton.hide();
            tg.BackButton.offClick(handleBackClick);
        }

        // Cleanup при размонтировании - ВСЕГДА убираем обработчик и скрываем кнопку
        return () => {
            tg.BackButton.offClick(handleBackClick);
            tg.BackButton.hide();
        };
    }, [isOpen]);
};